import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import M from "materialize-css/dist/js/materialize.min.js";
import Modal from "../../../helper/modal";
import TableHeader from "../../../helper/tableHeader";
import $ from "jquery";
import { unlockCollateral } from "../../../../actions/orderbook/set";
import { colors, tokenDictionary, shortenHash } from "../../../../config";
import "./matched.css";
import TransferDetails from "../../../helper/transferDetails";
import { take } from "ramda";
import InfiniteScroll from 'react-infinite-scroll-component';

const { green, red } = colors;

class MatchedOrders extends Component {
  constructor() {
    super();
    this.state = {unlocking:{},txData:[],hasMore:false,nextIndex:1,orders:[]}
  }
  componentDidUpdate(prevProps){
    if(prevProps.orders.length === 0 && this.props.orders.length > 0){
      this.setState({orders:take(20,this.props.orders)})
    }
    else if(this.props.orders.length != prevProps.orders.length){
      this.setState({hasMore:true,orders:take(this.state.nextIndex*20,this.props.orders)})
    }
  }
  componentDidMount(){
    this.setState({orders:take(20,this.props.orders),hasMore:true})
  }
  fetchMoreData(){
    let { nextIndex, orders} = this.state;
    nextIndex++;
    this.setState({orders:take(20*nextIndex,this.props.orders),nextIndex})
    if(20*nextIndex >= this.props.orders.length){
      this.setState({hasMore:false,nextIndex})
    }
    return;
  }
  renderUnlock() {
    let component = <div style={{overflowY:'scroll',maxHeight:'500px'}}>
      {this.state.txData.map(({amount},i)=>{
        return (
          <>
          <div className='row mbd'>
            <div className="row mi">
              <h6 className='leftInfo'><b>Collateral</b></h6>
              <h6 className="rightInfo">{amount} OVERLINE</h6>
            </div>
          </div>
          {i != this.state.txData.length - 1 && <br/>}
          </>
        )
      })}
    </div>

    return (
      <Modal id="modalUnlock" component={component} style={{maxWidth:'500px'}} noClose={true} classes="modal modalOrders black-text" title="Unlock Confirmation" decryption={true} buttonText={"Confirm"} passwordId="unlockpass" buttonAction={this.submitOperationUnlock.bind(this)} />
    );
  }
  submitOperationUnlock() {
    let password = $("#unlockpass").val();
    this.props.unlockCollateral({password,txData: this.state.txData}, (err, tx) => {
        if (!err) {
          var instance = M.Modal.getInstance(document.querySelectorAll("#modalUnlock")[0]);
          if (instance) instance.close();
          $("#unlockpass")[0].value = "";
          M.toast({ html: "Transaction Submitted!", classes: "green", displayLength: 2000});
          let unlocking = this.state.unlocking;
          this.state.txData.map(({txHash,txOutputIndex})=>{
            unlocking[`${txHash}.${txOutputIndex}.unlock`] = true;
          })
          this.setState({unlocking})
        } else {
          M.toast({ html: err, classes: "red", displayLength: 2000 });
        }
      }
    );
  }
  handleAllUnlock(){
    let txData = this.props.orders.filter(({unlocking,unlock,txHash,txOutputIndex,yourStatus,theirStatus,receivesToChain})=> {
      if(unlocking || this.state.unlocking[`${txHash}.${txOutputIndex}.unlock`]) return false;
      if(unlock.makerLeft > 0 || unlock.takerLeft > 0 || unlock.bcLeft > 0) return false;
      if((yourStatus || (!yourStatus && !theirStatus && receivesToChain !=='NRG'))) return true;
      else return false;
    }).map(({address,collateral,txHash,txOutputIndex}) => {
      return {amount:collateral,txHash,txOutputIndex,address}
    })
    if(txData.length === 0) {
      M.toast({html: 'No Orders to Unlock',classes: "red",displayLength:3000});
    }
    else {
      this.setState({txData});
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock')[0]);
      if(instance) instance.open();
      setTimeout(()=>{
        if($("#unlockpass2")) $("#unlockpass2").focus()
      },100)
    }
  }
  handleFormSubmitUnlock({ address, txHash, txOutputIndex, amount}) {
    let txData = [{amount,txHash,txOutputIndex,address}]
    this.setState({txData});

    var instance = M.Modal.getInstance(document.querySelectorAll("#modalUnlock")[0]);
    if (instance) instance.open();
    setTimeout(() => {
      if ($("#unlockpass")) $("#unlockpass").focus();
    }, 100);
  }
  renderItems(orders) {
    let ordersToFulfill = {};
    return orders.map(({address,unlock,maker,sendsToAddress,receivesFromAddress,sendsFromChain,receivesToChain,sendsAmount,receivesAmount,sendsFromAddress,unlocking,receivesToAddress,yourStatus,theirStatus,collateral,deadline,txHash,txOutputIndex},i) => {

        let unlockClick = this.handleFormSubmitUnlock.bind(this, {address, txHash, txOutputIndex, amount: collateral});
        let you = <a style={{ color: red }}>Asset Never Sent</a>;

        if (sendsFromChain === "NRG" && theirStatus) you = <a style={{color: "grey"}}>{receivesToChain} Received</a>;
        else if (yourStatus || (!yourStatus && !theirStatus && receivesToChain !=='NRG')) {
          you = <button onClick={unlockClick} className="btn clickables" >Unlock</button>;
          if (unlocking || this.state.unlocking[`${txHash}.${txOutputIndex}.unlock`]) you = <a style={{ color: "grey" }}>{`Unlocking`} </a>;
        }
        return (
          <tr key={i} className="matched" onMouseOver={()=>{console.log({txHash, txOutputIndex})}}>
            <td className="matchedSend">
              {`${sendsAmount}`} {sendsFromChain.replace('NRG','OVERLINE')} to {`${shortenHash(sendsToAddress, 6)}`}
            </td>
            <td className="matchedReceive">
              {`${receivesAmount}`} {receivesToChain.replace('NRG','OVERLINE')} to {`${shortenHash(receivesToAddress, 6)}`}
            </td>
            <td className="matchedCollateral">
              {collateral} OVERLINE
            </td>
            <td className="matchedDeadline" style={{ lineHeight: "25px", fontSize: "10px" }}>
              {you}
            </td>
          </tr>
        );
      }
    );
  }
  render() {
    let items = ["Send", "Receive", "Collateral", "Status"];
    let classes = ["matchedSend", "matchedReceive", "matchedCollateral", "matchedDeadline", "matchedStatus"];
    let noOrders = this.props.orders.length == 0;
    let {orders} = this.state;

    return (
      <div className="col m6" style={{ paddingLeft: "0.375rem", marginTop: "5px"}}>
        <h6 style={{ marginTop: "10px", marginLeft: "2px", color: "white",float:'left' }}>
          <span style={{ cursor: "pointer", paddingRight: "10px", color: "white" }}>
            {`Matched Unlockable Orders (${this.props.orders.length})`}
          </span>
        </h6>

        {this.props.orders.length > 0 &&
          <h6 style={{marginTop:'10px',float:'right'}} onClick={this.handleAllUnlock.bind(this)}>
            <span className='hoverC' style={{cursor:'pointer',paddingRight:'10px',color:'grey'}}>
            Unlock All
            </span>
          </h6>
        }

        <div className="col s12 section">
          <TableHeader items={items} classes={classes} />
          <div className="col s12 myOrders">
            <InfiniteScroll
             className="infiniteScrollComponent"
                  height={200}
                  dataLength={orders.length}
                  next={this.fetchMoreData.bind(this)}
                  hasMore={this.state.hasMore}
                  loader={<p>Loading...</p>}
              >
              <table className="white-text order-book striped" style={{tableLayout:"fixed",fontSize:"0.9em",height:'30px',lineHeight:'30px'}}>
              <tbody/>
            {this.renderItems(orders)}
            <tbody/>
            </table>
            {noOrders ?
              <p style={{color:'grey',marginLeft:'5px',marginTop:0,fontSize:'10px'}}> No Orders</p>
              : null
            }
          </InfiniteScroll>
          </div>
        </div>
        {this.renderUnlock()}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    wallet: state.passport.wallet,
    fee: state.passport.fee,
    orders: state.orderbook.my_past_orders,
  };
}

export default connect(mapStateToProps, {unlockCollateral})(MatchedOrders);
